export default {
      id: "i-paper-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/sprite.svg#i-paper",
      toString: function () {
        return this.url;
      }
    }